export const creatorAddresses = [
    {label: 'R_Current', value:'https://kreator.comarchesklep.pl/'}
]

export const getCreatorAddresses = function(getTranslation) {
    const addresses = creatorAddresses.map( element => {
        //Object mutation!!!
        return {label: getTranslation(element.label), value: element.value };
    });

    return addresses;
}